/* eslint max-len: 0 */
import React, { SVGProps } from 'react';

const PhoneVoice = (props: SVGProps<SVGSVGElement>): JSX.Element => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="icon icon--phoneVoice"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.0563 1.58527C3.3027 1.421 3.59221 1.33334 3.88835 1.33334H4.67177C5.31741 1.33334 5.89062 1.74649 6.09479 2.359L6.86688 4.67526C7.01326 5.1144 6.94869 5.59651 6.69193 5.98166L6.20606 6.71047C6.16199 6.77657 6.1707 6.86459 6.22688 6.92077L9.07891 9.7728C9.13509 9.82898 9.22311 9.8377 9.28922 9.79363L10.018 9.30775C10.4032 9.05099 10.8853 8.98643 11.3244 9.1328L13.6407 9.90489C14.2532 10.1091 14.6663 10.6823 14.6663 11.3279V12.1113C14.6663 12.4075 14.5787 12.697 14.4144 12.9434L13.9088 13.7019C13.5069 14.3046 12.8304 14.6667 12.106 14.6667H11.4391C11.241 14.6667 11.045 14.6275 10.8621 14.5513L7.50415 13.1521C5.39957 12.2752 3.68056 10.6707 2.66094 8.63143L1.49137 6.29229C1.38723 6.08401 1.33301 5.85434 1.33301 5.62147V3.53691C1.33301 3.03538 1.58366 2.56703 2.00096 2.28883L3.0563 1.58527ZM3.88835 2.66668C3.85545 2.66668 3.82328 2.67642 3.7959 2.69467L2.74056 3.39823C2.69419 3.42914 2.66634 3.48118 2.66634 3.53691V5.62147C2.66634 5.64734 2.67237 5.67286 2.68394 5.696L3.8535 8.03514C4.73003 9.78818 6.20777 11.1675 8.01697 11.9214L11.375 13.3205C11.3953 13.329 11.4171 13.3333 11.4391 13.3333H12.106C12.3846 13.3333 12.6448 13.1941 12.7994 12.9623L13.305 12.2038C13.3233 12.1764 13.333 12.1442 13.333 12.1113V11.3279C13.333 11.2562 13.2871 11.1925 13.219 11.1698L10.9028 10.3977C10.854 10.3815 10.8004 10.3886 10.7576 10.4172L10.0288 10.903C9.43388 11.2997 8.6417 11.2212 8.1361 10.7156L5.28407 7.86358C4.77847 7.35798 4.70003 6.5658 5.09666 5.97087L5.58253 5.24206C5.61106 5.19926 5.61823 5.14569 5.60197 5.0969L4.82988 2.78064C4.8072 2.71258 4.74351 2.66668 4.67177 2.66668H3.88835Z"
        fill="white"
      />
    </svg>
  );
};

PhoneVoice.displayName = 'phoneVoice';

export default PhoneVoice;
